import { handleResponseError } from "helpers/utils"
import { API } from "./endpoint"
import { AxiosResponse } from "axios"
import httpClient from '../axios/interceptors'
import {  CreateDeliveryInput, CreateParkingInput, CreateParkingResponse, DeleteDeliveryInput, DeleteParkingInput, DeliveryPointResponse, ExportTransportInprocessResponse, ExportTransportShippedResponse, GetDeliveryInput, GetOrderDetailResponse, GetParkingByIdResponse, GetParkingListResponse, GetParkingTransportAreaTypeInput, GetParkingTransportDistrictTypeInput, GetParkingTransportProvinceTypeInput, GetParkingTransportTypeInput, GetPrepareShipInput, GetPrepareShipResponse, GetTransportOrderDetailInput, GetTransportShipedResponse, GetTransportShippedDetailInput, GetTransportShippedDetailResponse, ParkingTransportAreaTypeResponse, ParkingTransportDistrictTypeResponse, ParkingTransportProvinceTypeResponse, ParkingTransportTypeResponse, UpdateDeliveryInput, UpdateParkingInput } from "./interface"


export const getPrepareShip = async (
    input: GetPrepareShipInput
  ): Promise<GetPrepareShipResponse> => {
    const data: AxiosResponse<GetPrepareShipResponse> = await httpClient
      .post(API.prepareShip, input)
      .catch((error) => handleResponseError(error))
    return data.data
  }

  export const getExportTransportInprocess = async (): Promise<ExportTransportInprocessResponse> => {
    const data: AxiosResponse<ExportTransportInprocessResponse> = await httpClient
      .get(API.exportTransportInprocess)
      .catch((error) => handleResponseError(error))
    return data.data
  }

  export const getTransportOrderDetail = async (
    input: GetTransportOrderDetailInput
  ): Promise<GetOrderDetailResponse> => {
    const data: AxiosResponse<GetOrderDetailResponse> = await httpClient
      .post(API.getTransportOrderdetail, input)
      .catch((error) => handleResponseError(error))
    return data.data
  }

  export const getTransportShipped = async (
    input: GetPrepareShipInput
  ): Promise<GetTransportShipedResponse> => {
    const data: AxiosResponse<GetTransportShipedResponse> = await httpClient
      .post(API.getTransportShipped, input)
      .catch((error) => handleResponseError(error))
    return data.data
  }

  export const getTransportShippedOrderDetail = async (
    input: GetTransportShippedDetailInput
  ): Promise<GetTransportShippedDetailResponse> => {
    const data: AxiosResponse<GetTransportShippedDetailResponse> = await httpClient
      .post(API.getTransportShippedDetail, input)
      .catch((error) => handleResponseError(error))
    return data.data
  }

  export const getExportTransportShhiped = async (): Promise<ExportTransportShippedResponse> => {
    const data: AxiosResponse<ExportTransportShippedResponse> = await httpClient
      .get(API.exportTransportShipped)
      .catch((error) => handleResponseError(error))
    return data.data
  }

  export const getParkingList = async (input: string): Promise<GetParkingListResponse> => {
    const data: AxiosResponse<GetParkingListResponse> = await httpClient
      .get(API.getParkingList + input)
      .catch((error) => handleResponseError(error))
    return data.data
  }

  export const createParking = async (
    input: CreateParkingInput
  ): Promise<CreateParkingResponse> => {
    const data: AxiosResponse<CreateParkingResponse> = await httpClient
      .post(API.createParking, input)
      .catch((error) => handleResponseError(error))
    return data.data
  }

  export const updateParking = async (
    input: UpdateParkingInput
  ): Promise<CreateParkingResponse> => {
    const data: AxiosResponse<CreateParkingResponse> = await httpClient
      .post(API.updateParking, input)
      .catch((error) => handleResponseError(error))
    return data.data
  }

  export const deleteParking = async (
    input: DeleteParkingInput
  ): Promise<CreateParkingResponse> => {
    const data: AxiosResponse<CreateParkingResponse> = await httpClient
      .post(API.deleteParking, input)
      .catch((error) => handleResponseError(error))
    return data.data
  }


  export const getParkingById = async (input: string): Promise<GetParkingByIdResponse> => {
    const data: AxiosResponse<GetParkingByIdResponse> = await httpClient
      .get(API.getParkingById + input)
      .catch((error) => handleResponseError(error))
    return data.data
  }

  //get delivery point
  export const getDeliveryPoint = async (input: GetDeliveryInput): Promise<DeliveryPointResponse> => {
    const data: AxiosResponse<DeliveryPointResponse> = await httpClient
      .post(API.getDeliveryPoint, input)
      .catch((error) => handleResponseError(error))
    return data.data
  }

  //create delivery point
  export const createDeliveryPoint = async (input: CreateDeliveryInput): Promise<DeliveryPointResponse> => {
    const data: AxiosResponse<DeliveryPointResponse> = await httpClient
      .post(API.createDeliveryPoint, input)
      .catch((error) => handleResponseError(error))
    return data.data
  }

//delete delivery point
export const deleteDeliveryPoint = async (input: DeleteDeliveryInput): Promise<DeliveryPointResponse> => {
  const data: AxiosResponse<DeliveryPointResponse> = await httpClient
    .post(API.deleteDeliveryPoint, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

//update delivery point
export const updateDeliveryPoint = async (input: UpdateDeliveryInput): Promise<DeliveryPointResponse> => {
  const data: AxiosResponse<DeliveryPointResponse> = await httpClient
    .post(API.updateDeliveryPoint, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getParkingTransportProvinceType = async(input: GetParkingTransportProvinceTypeInput): Promise<ParkingTransportProvinceTypeResponse> => {
  const data: AxiosResponse<ParkingTransportProvinceTypeResponse> = await httpClient
    .post(API.getParkingTransportProvinceType, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

  ///parking/transport_type/district
  export const getParkingTransportDistrictType = async(input: GetParkingTransportDistrictTypeInput): Promise<ParkingTransportDistrictTypeResponse> => {
    const data: AxiosResponse<ParkingTransportDistrictTypeResponse> = await httpClient
      .post(API.getParkingTransportDistrictType, input)
      .catch((error) => handleResponseError(error))
    return data.data
  }

    ///parking/transport_type
    export const getParkingTransportType = async(input: GetParkingTransportTypeInput): Promise<ParkingTransportTypeResponse> => {
      const data: AxiosResponse<any> = await httpClient
        .post(API.getParkingTransportType, input)
        .catch((error) => handleResponseError(error))
      return data.data
    }

      ///parking/transport_type/area
  export const getParkingTransportAreaType = async(input: GetParkingTransportAreaTypeInput): Promise<ParkingTransportAreaTypeResponse> => {
    const data: AxiosResponse<any> = await httpClient
      .post(API.getParkingTransportAreaType, input)
      .catch((error) => handleResponseError(error))
    return data.data
  }

